import React, { useState, useEffect } from 'react';
import { observer } from 'mobx-react';

import UIStore from '../stores/UIStore';
import UserStore from '../stores/UserStore';
import Feedback from 'components/Feedback';

import { useQueryParameters } from '@partsbadger/utils';
import { useHistory } from 'react-router';

import AuthLayout from 'components/AuthLayout';
import { Card, Col, Row, Tag, Typography } from 'antd';
import UTMQueryPreservingLink from '../common/UTMQueryPreservingLink';
import RedirectPreservingUTMQuery from '../common/RedirectPreservingUTMQuery';
import ResetPassword from "@/components/AuthLayout/ResetPassword";

const PortalResetPassword = () => {
    const query = useQueryParameters();
    const feedback_sales_order_name = query.get('feedback_sales_order');

    const next_url = query.get('next') || '/my-account/';
    const history = useHistory();
    const [isModalVisible, setIsModalVisible] = useState(false);
    const redirectToPortal = () => {
        history.push('/my-account/');
    };

    useEffect(() => {
        if (feedback_sales_order_name) {
            setIsModalVisible(true);
        } else {
            UIStore.setSelectedKey(['my-account']);
            UIStore.setDocumentTitle('Login');
        }
    }, []);

    if (UserStore.isAuthenticated && !feedback_sales_order_name) {
        return <RedirectPreservingUTMQuery to={next_url} />;
    }

    const {  email } = UserStore.guest_data || {};


    return (
        <>
            <Card className="p-4 m-5 shadow-xl py-5 mx-auto">
                        <ResetPassword email={email} />
            </Card>
        </>
    );
};

export default observer(PortalResetPassword);
